import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { observer } from "mobx-react-lite";
import "./Upload.scss";

import Svg from "../svg/Svg";
import { DragDrop } from "../svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";
import { FileExtended } from "../../services/upload/FileUploadTracker";
import { FileTypesStorageModel } from "./FileTypesStorage";
import { api } from "../../services/api/ApiService";

interface DropFilesProps {
  onDroppedFiles: (files: Array<FileExtended>) => void;
  singleFile?: boolean;
  fileTypesAccepted?: string;
}

export default observer(function DropFiles(props: DropFilesProps) {
  const { onDroppedFiles, singleFile = true, fileTypesAccepted } = props;

  const [fileTypesStorage] = useState(() =>
    FileTypesStorageModel.create({ autoLoad: false }, { api })
  );

  useEffect(() => {
    if (!fileTypesAccepted) fileTypesStorage.load();
  }, [fileTypesAccepted, fileTypesStorage]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    noDragEventsBubbling: true,
    multiple: !singleFile,
    accept: fileTypesAccepted ? fileTypesAccepted : fileTypesStorage.acceptedFileTypes,
  });
  const { themeClass } = useThemeService();

  function onDrop(acceptedFiles: Array<File>) {
    const mappedFiles: Array<FileExtended> = acceptedFiles.map(
      (acceptedFile) =>
        new FileExtended(acceptedFile, (acceptedFile as unknown as FileExtended).path)
    );
    onDroppedFiles(mappedFiles);
  }

  return (
    <div>
      <div {...getRootProps({ className: themeClass(["dropzone"]) })}>
        <input id="upload-input" {...getInputProps()} />
        <Svg svg={DragDrop} />
        <div>
          <p> {translationService.translate("general.upload.drag-and-drop-instruction1")}</p>
          <p> {translationService.translate("general.upload.drag-and-drop-instruction2")}</p>
        </div>
      </div>
    </div>
  );
});
